module.exports = __webpack_public_path__ + "pray.eaa56ca0.png";